import React, { useEffect, useState } from "react";
import LigCustomModal from "../../../assets/components/LigCustomModal";
import Classes from "./styles/style.module.css";
import EitaIcon from "../../../assets/images/icons/eitaIcon.png";
import PhoneIcon from "../../../assets/images/icons/phoneIcon.png";
import GearsIcon from "../../../assets/images/icons/gerarsIcon.png";
import { useSelector, useDispatch } from "react-redux";
import UsersRequests from "../../../assets/services/user";
import api from "../../../assets/utils/Api";
import errorHandler from "../../../assets/utils/ErrorHandler";
import Loading from "../../../assets/containers/loadingDialog";

const LigHelp = ({ show, closeHander }) => {
  const { currentUser } = useSelector(({ user }) => user);
  const [nationalCode, setNationalCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [supportInfo, setSupportInfo] = useState(null);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(UsersRequests.getme());
  }, []);

  useEffect(() => {
    if (currentUser?.nationalCode) {
      setNationalCode(currentUser.nationalCode);
    }
  }, [currentUser]);

  useEffect(() => {
    if (nationalCode) {
      getSupportInfo();
    }
  }, [nationalCode]);

  const handleCall = function () {
    if (supportInfo?.supportPhone) {
      window.location.href = `tel:0${supportInfo.supportPhone}`;
    } else {
      return;
    }
  };

  const openInEita = function () {
    if (supportInfo?.supportId) {
      const url = `https://eitaa.com/${supportInfo.supportId}`;
      window.open(url, "_blank");
    } else {
      return;
    }
  };

  const openSupport = function () {
    const url = `https://eitaa.com/royinsoft`;
    window.open(url, "_blank");
  };

  const getSupportInfo = async () => {
    setLoading(true);
    try {
      let response = await api.post("/accessLig/check", {
        identifier: nationalCode,
        topic: "Lig",
      });
      setSupportInfo(response.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      errorHandler(error);
    }
  };

  const dialogContent = (
    <div className={"w-100"}>
      <h5 className="mb-4"> ارتباط با پشتیبانی </h5>
      {loading ? (
        <div className="w-100 d-flex justify-content-center my-5">
          <Loading />
        </div>
      ) : (
        <>
          <p>
            نام پشتیبان :{" "}
            {supportInfo?.supportName ? supportInfo.supportName : "تعریف نشده"}
          </p>
          <div className="d-flex">
            <div
              className={`${Classes.itemContainer} ${
                supportInfo?.supportId ? "" : Classes.disabled
              }`}
              onClick={openInEita}
            >
              <img src={EitaIcon} alt="eita" />
              <p>پیامرسان ایتا</p>
            </div>
            <div
              className={`${Classes.itemContainer} ${
                supportInfo?.supportPhone ? "" : Classes.disabled
              }`}
              onClick={handleCall}
            >
              <img src={PhoneIcon} alt="phone" />
              <p>تماس تلفنی</p>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className={`${Classes.itemContainer}`} onClick={openSupport}>
              <img src={GearsIcon} alt="phone" />
              <p>پشتیبانی فنی</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
  return (
    <LigCustomModal
      open={show}
      closeHandler={closeHander}
      dialogContent={dialogContent}
    />
  );
};

export default LigHelp;
